/* eslint-disable react/display-name */
import Typography from 'common/components/Typography'
import theme from 'common/theme'
import { useFeatureFlags } from 'lib/feature-flags'
import React, { useEffect } from 'react'
import { ISuggestion } from 'services/Product/stores/models/SearchSuggestionModel/interface'
import SeeAllButtonWrappper from 'services/Search/components/SeeAllButton'
import DigitalGoods from 'services/Search/widgets/SuggestionsContent/DigitalGoods'
import FrequentlyAskQuestion from 'services/Search/widgets/SuggestionsContent/FrequentlyAskQuestion'
import Items from 'services/Search/widgets/SuggestionsContent/Items'
import News from 'services/Search/widgets/SuggestionsContent/News'
import Pavilion from 'services/Search/widgets/SuggestionsContent/Pavilion'
import Seller from 'services/Search/widgets/SuggestionsContent/Seller'
import Tender from 'services/Search/widgets/SuggestionsContent/Tender'
import styled from 'styled-components'

const SearchResultWrapper = styled.div`
  p {
    margin: 0px;
    vertical-align: middle;
    font-size: 13px;
  }
  svg {
    margin-top: 11px;
    margin-right: 10px;
  }
  li {
    line-height: 35px;
    padding-left: 20px;
    padding-right: 20px;
  }
  li: hover {
    background-color: ${theme.colors.grayLighter};
  }
  > p {
    margin-bottom: 5px;
    margin-left: 20px;
  }
`

const SuggestionLabelWrapper = styled.div`
  margin-left: 20px;
  margin-right: 20px;
  display: flex;
  justify-content: space-between;
`

interface ISuggestionContain {
  suggestions: ISuggestion[]
  keywords: string
  cursor: number
  setTotalSuggestions: Function
}

const SuggestionContentMapper = ({
  code,
  item,
  keywords,
  isHighlited,
}): JSX.Element => {
  const suggestionContent = {
    item: (
      <Items
        suggestionItem={item}
        keywords={keywords}
        isHighlited={isHighlited}
      />
    ),
    seller: (
      <Seller
        suggestionItem={item}
        keywords={keywords}
        isHighlited={isHighlited}
      />
    ),
    digitalgoods: (
      <DigitalGoods
        suggestionItem={item}
        keywords={keywords}
        isHighlited={isHighlited}
      />
    ),
    tender: (
      <Tender
        suggestionItem={item}
        keywords={keywords}
        isHighlited={isHighlited}
      />
    ),
    pavilion: (
      <Pavilion
        suggestionItem={item}
        keywords={keywords}
        isHighlited={isHighlited}
      />
    ),
    faq: (
      <FrequentlyAskQuestion
        suggestionItem={item}
        keywords={keywords}
        isHighlited={isHighlited}
      />
    ),
    news: (
      <News
        suggestionItem={item}
        keywords={keywords}
        isHighlited={isHighlited}
      />
    ),
  }

  return suggestionContent[code] || null
}

const SuggestionContain = React.forwardRef<
  HTMLDivElement,
  ISuggestionContain
>(
  (
    {
      cursor,
      keywords,
      suggestions,
      setTotalSuggestions,
      ...props
    }: ISuggestionContain,
    ref: React.MutableRefObject<null>,
  ): JSX.Element => {
    const isEnableSeeAllButton = useFeatureFlags(
      'rel--see-all-button--website',
    )

    let startIndex = {}
    useEffect(() => {
      setTotalSuggestions(0)
      suggestions.forEach((_val, idx) => {
        setTotalSuggestions(
          (prev) => prev + suggestions[idx].items.length,
        )
      })
    }, [suggestions])
    return (
      <div ref={ref} {...props}>
        {suggestions.map((suggestion, suggestionIndex) => {
          if (suggestionIndex === 0) {
            startIndex = { [suggestionIndex]: 0 }
          } else {
            startIndex = {
              ...startIndex,
              [suggestionIndex]:
                startIndex[suggestionIndex - 1] +
                suggestions[suggestionIndex - 1].items.length,
            }
          }
          if (suggestion.items.length > 0) {
            return (
              <SearchResultWrapper
                data-testid="search-suggestion-section"
                key={String(`suggestion-${suggestionIndex}`)}
              >
                <SuggestionLabelWrapper data-testid="see-all-item">
                  <Typography
                    fontSize="13px"
                    fontWeight="bold"
                    data-testid="search-suggestion-title"
                  >
                    {suggestion.title}
                  </Typography>
                  {isEnableSeeAllButton ? (
                    <SeeAllButtonWrappper
                      code={suggestion.code}
                      keyword={keywords}
                    >
                      Lihat Semua
                    </SeeAllButtonWrappper>
                  ) : null}
                </SuggestionLabelWrapper>

                <ul>
                  {suggestion.items.map((item, idx) => {
                    return (
                      <SuggestionContentMapper
                        code={suggestion.code}
                        item={item}
                        keywords={keywords}
                        key={String(
                          `search-list-${suggestion.code}-${idx}`,
                        )}
                        isHighlited={
                          cursor === startIndex[suggestionIndex] + idx
                        }
                      />
                    )
                  })}
                </ul>
              </SearchResultWrapper>
            )
          }
          return null
        })}
      </div>
    )
  },
)

export default SuggestionContain
